exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cq-result[data-v-4c16be12]{padding:12px}.cq-result-panel[data-v-4c16be12]{background:#fff;border-radius:4px;padding:16px 20px 20px;box-shadow:0 1px 4px rgba(0,0,0,.04)}.cq-result-toolbar[data-v-4c16be12]{text-align:right;margin-bottom:12px}.cq-result-page-bar[data-v-4c16be12]{text-align:right;margin-top:16px;display:flex;align-items:center;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c16be12","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--5!./src/component/data-grid/custom-query/views/query-result.vue
// module id = 137
// module chunks = 0